import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import reload from "../../assets/icons/reload.svg";
import CustomTabsV2 from "../universal/CustomTabsV2";
import CollapsibleRightPanel from "../universal/CollapsibleRightPanel";
import useResponsiveTabsPerSlide from "../universal/useResponsiveTabsPerSlide";
import { AddChurchHooks ,AllChurchHooks} from "../../screens/Ministry/hooks/Ministryhooks";
// import { AllChurchHooks } from "./hooks/Ministryhooks";

import LayoutDropdown from "../universal/LayoutDropdown";
import edit from "../../assets/icons/edit.svg";
import close from "../../assets/icons/close.svg";
import LanguageDrawer from "../universal/LanguageDrawer";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { FaInfoCircle } from "react-icons/fa";
import UploadControlsV2 from "../TWG/UploadControlsV2";
import GoogleMapInput from "../../components/MapInput/MapInput";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {fetchChurchByIdRequest } from "../../store/Churches/actions";
import { readEntityContentDetailsRequest } from "../../store/EntityAnalytics/entityAnalyticsActions";
import { readEntityContentViewsAnalytics } from "../../store/EntityAnalytics/entityAnalyticsApi";
import { FaArrowRight } from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa";
import AllResources from '../../screens/Resources/AllResource';
import AllCarecells from "../../screens/Carcells/allcarcells";
import AllPrograms from "../../screens/Program/AllProgram";
import AllTeam from "../../screens/Teams/AllTeam";
import AllBulletin from '../../screens/Bulletin/allbulletin';
import AllCategories from "../../screens/Categories/AllCategories";
import AllCurriculum from "../../screens/Addcurriculum/CurriculumList.jsx";
// ministriesObjId
import AllTwg from "../../screens/TWG/AllTwg";
import AllJournals from "../../screens/AddJournal/JournalList";

import Resources from "../../screens/Resources/Resource";
import Carecells from "../../screens/Carcells/carcells"
import Program from '../../screens/Program/Program'
import Teams from "../../screens/Teams/Teams";
import Billetins from "../../screens/Bulletin/bulletin";
import Videos from "../../screens/Videos/Videos";
import Categories from "../../screens/Categories/Categories";
import Curriculum from "../../screens/Curriculum/Curriculum";
import Twg from "../../screens/TWG/Twg";
import Journals from "../../screens/Journals/Journals";
import Galleryfield from "../ImageGallery/galleryfield";
import Campuses from "../Campuses/AllCampus";
import Service from "../Service/serviceTab"
// import GalleryPickerField from "../../components/ImageGallery/GalleryPickerField"
import CoverImage from "../MinistryCover/Coverimage.js";
import VideoGalleryField from "../MinistryVideo/galleryfield.jsx";
import Video from "../MinistryCoverVideo/Video";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ReactModal from "react-modal";
import { ImCross } from "react-icons/im";
import ChurchPrayer from "../../screens/Prayers/ChurchesPrayer.js"
import AllPlans from "../../screens/Plan/AllPlan";
import SermonPlans from "../../screens/Plan/SermonPlans";
import NotificationsComponent from "../../screens/Notification/userNotificatoin.js";
function sanitizeQuill(html) {
  return html.replace(
    /background-color\s*:\s*[^;"]+;?/gi,
    ""
  );
}
const   AddVideosFields = ({ setLoading, data,onClose,church }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
    const location = useLocation();
  const isAddMinistryRoute = location.pathname.toLowerCase().includes("addministryfield");
  const stateHasChurch = Object.prototype.hasOwnProperty.call(
    location.state || {},
    "church"
  );
  const isCreateMode =
    location.state?.mode === "create" || (stateHasChurch && location.state?.church === null);
  const tabParam = new URLSearchParams(location.search).get("tab");
  const allowStoredMinistry = Boolean(tabParam && tabParam !== "Ministries");
  const [selectedMinistry, setSelectedMinistry] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("ministry"));
    } catch {
      return null;
    }
  });
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === "ministry") {
        try {
          setSelectedMinistry(JSON.parse(e.newValue));
        } catch {
          setSelectedMinistry(null);
        }
      }
    };
    const onMinistryChange = (e) => {
      if (e?.detail) {
        setSelectedMinistry(e.detail);
      }
    };
    window.addEventListener("storage", onStorage);
    window.addEventListener("ministry:change", onMinistryChange);
    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("ministry:change", onMinistryChange);
    };
  }, []);
  const resolvedChurch = isCreateMode
    ? null
    : church ||
      (isAddMinistryRoute && !stateHasChurch
        ? allowStoredMinistry
          ? selectedMinistry
          : null
        : selectedMinistry);
  const rowData = isCreateMode
    ? null
    : stateHasChurch
    ? location.state?.church
    : resolvedChurch;
     const {
    activeTab,
    activeLanguageDetails,
    setActiveLanguageDetails,
    setActiveTab,
    setIsLayoutEdit,
    handleInputChange,
    handleFileInputChange,
    handleSave,
    readLanguageData,
    videoInputs,
    videoErrors,
    setTumbNailUrlsInputs,
    tumbNailUrlsInputs,
    handleChange,
    setLayoutValues,
    handleVideoLayoutChange,
    layoutValues,
    initialLayoutValues,
    setLayoutInfo,
    layoutInfo,
    handleAddLayoutToArray,
    layoutArray,
    setAddedLayout,
    addedLayout,
    isLayoutEdit,
    setEditLayoutIndex,
    setEditTargetLayout,
    editTargetLayout,
    handleLayoutUpdate,
    updateStateWithTranslation,
    languagemeta,
    setIsLanguageSave,
    handleSaveLanguage,
    handleSendNotification,
    handleUpdateChurch,
    handleDeleteLayoutFromArray,

  } = AddChurchHooks(setLoading, data);

  const [showModal, setShowModal] = useState(false);
  const [isImage, setIsImage] = useState(false);
  const [currentUrl, setCurrentUrl] = useState("");
  const [selectedLocation, setSelectedLocation] = useState({
    lat: "",
    lng: "",
    address: "",
  });
  const [tabViews, setTabViews] = useState(null);
  const [tabCount, setTabCount] = useState(null);
  const [viewsSummary, setViewsSummary] = useState(null);

 const tabs = [
  "Ministries","Image Gallery","Cover Image","Video Gallery","Cover Video","Leadership Team","Programs","Curriculum","Journals","Prayer","Plan","Sermon Plans","Notifications"];
  const tabComponents = {
    "Resources": AllResources,
    "Carecells": AllCarecells,
    "Programs": AllPrograms,
    "Leadership Team": AllTeam,
    "Bulletins": AllBulletin,
    "Categories": AllCategories,
    "Curriculum": AllCurriculum,
    "Daily Devotion": AllTwg,
    "Journals": AllJournals,
    "Video Gallery":VideoGalleryField,
    "Cover Video":Video,
    "Image Gallery":Galleryfield,
    "Cover Image":CoverImage,
    "Prayer":ChurchPrayer,
    "Plan": AllPlans,
    "Sermon Plans": SermonPlans,
    "Notifications": NotificationsComponent

  };
  const SidetabComponents = {
    "Resources": Resources,
    "Carecells": Carecells,
    "Programs": Program,
    "Leadership Team": Teams,
    "Bulletins": Billetins,
    "Videos": Videos,
    "Categories": Categories,
    "Curriculum": Curriculum,
    "Video Gallery":Journals,
    "Daily Devotion": Journals,
    "Journals": Journals,
    "Image Gallery":Journals,
    "Cover Video":Journals,

    "Cover Image":Journals,
    "Prayer":Journals,
    "Plan": Journals,
    "Sermon Plans": Journals,
    "Notifications": Journals





  };

  const contentTypeByTab = {
    "Video Gallery": "videos",
    "Cover Video": "videos",
    "Videos": "videos",
    "Curriculum": "curriculums",
    "Plan": "plans",
    "Campuses": "campuses",
    "Carecells": "carecells",
    "Journals": "journals",
    "Leadership Team": "members",
    "Programs": "programs",
    "Services": "services",
    "Bulletins": "bulletins",
  };


    const [formValues, setFormValues] = useState({
      _id: rowData?._id || "",
      churchName: rowData?.churchName || "",
      tagline: rowData?.tagline || "",
      description: rowData?.description || "",
      address: rowData?.address || "",
      latitude: rowData?.latitude || "",
      longitude: rowData?.longitude || "",
      contactemail: rowData?.contactemail || "",
      contactphone: rowData?.contactphone || "",
      website: rowData?.website || "",
      logourl: rowData?.logourl || "",
      giveUrl: rowData?.giveUrl || "", // ✅ FIXED

    });
    useEffect(() => {
      if (!rowData?._id) return;

      fetchAllChurches(
        1,
        0,
        {},
        (res) => {

          const churchData = res?.data?.[0];
          if (!churchData) return;




          setFormValues((prev) => ({
            ...prev, // ✅ keep anything user already typed
            _id: churchData._id || prev._id,
            churchName: churchData.churchName || prev.churchName,
            tagline: churchData.tagline || prev.tagline,
            description: churchData.description || prev.description,
            address: churchData.address || prev.address,
            latitude: churchData.latitude || prev.latitude,
            longitude: churchData.longitude || prev.longitude,
            contactemail: churchData.contactemail || prev.contactemail,
            contactphone: churchData.contactphone || prev.contactphone,
            website: churchData.website || prev.website,
            logourl: churchData.logourl || prev.logourl,
            giveUrl: churchData.giveUrl || prev.giveUrl, // ✅ NOW WORKS
          }));
        },
        rowData?._id // 🔥 THIS switches API to READ-BY-ID MODE
      );
    }, [rowData?._id, activeTab]);

       const handleLocalChange = (e) => {
      const { name, value } = e.target;

      // Map input "name" attributes to your state keys
      const nameMap = {
        church_title: "churchName",
        church_tagline: "tagline",
        church_description: "description",
        church_address: "address",
        church_latitude: "latitude",
        church_longitude: "longitude",
        church_email: "contactemail",
        church_phone: "contactphone",
        church_website: "website",
        church_logo_urls: "logourl",
        church_give_url: "giveUrl", // ✅ correct

      };

      const mappedName = nameMap[name] || name;

      setFormValues((prev) => ({
        ...prev,
        [mappedName]: value,
      }));

      // still call your original hook's handler
      handleChange(e);
    };
    const { tabsViewportRef, tabsPerSlide: max } = useResponsiveTabsPerSlide(tabs.length);
    const [slideIndex, setSlideIndex] = useState(0);
    const [activeTabs, setActiveTabs] = useState("Ministries");

    useEffect(() => {
      const tabParam = new URLSearchParams(location.search).get("tab");
      if (!tabParam) return;
      if (tabs.includes(tabParam)) {
        setActiveTabs(tabParam);
        const idx = tabs.indexOf(tabParam);
        setSlideIndex(Math.floor(idx / max));
      }
    }, [location.search]);


    // Calculate number of slides
    const totalSlides = Math.ceil(tabs.length / max);

    const handlePrev = () => {
      setSlideIndex((prev) => Math.max(prev - 1, 0));
    };

    const handleNext = () => {
      setSlideIndex((prev) => Math.min(prev + 1, totalSlides - 1));
    };

    useEffect(() => {
      const activeIndex = tabs.indexOf(activeTabs);
      if (activeIndex >= 0) {
        setSlideIndex(Math.floor(activeIndex / max));
      }
    }, [activeTabs, max]);

    // Determine visible tabs for the current slide
    const start = slideIndex * max;
    const visibleTabs = tabs.slice(start, start + max);
    const ActiveComponent = tabComponents[activeTabs];
    const SideActiveComponent = SidetabComponents[activeTabs];

   const { userInfo } = useSelector((state) => state.user);
   const { galleryList } = useSelector((state) => state.gallery || {});

  const hideUI = location.pathname.includes("addfield")|| userInfo?.roleCode==='17dwer8'||  location.pathname.includes("addMinistryField")||location.pathname.includes("addChannelField");

  useEffect(() => {
    if (!resolvedChurch?._id) {
      setViewsSummary(null);
      return;
    }
    let isActive = true;
    (async () => {
      try {
        const res = await readEntityContentViewsAnalytics({
          typeofentity: "3",
          churchObjId: resolvedChurch._id,
        });
        if (!isActive) return;
        const summary =
          res?.summary ||
          (Array.isArray(res?.data) ? res.data[0]?.views : {}) ||
          {};
        setViewsSummary(summary);
      } catch {
        if (isActive) setViewsSummary(null);
      }
    })();
    return () => {
      isActive = false;
    };
  }, [resolvedChurch?._id]);

  useEffect(() => {
    const contentType = contentTypeByTab[activeTabs];
    if (!resolvedChurch?._id) {
      setTabViews(null);
      setTabCount(null);
      return;
    }

    if (activeTabs === "Ministries") {
      setTabCount(resolvedChurch?._id ? 1 : 0);
      const entityViews =
        viewsSummary?.entityViews === 0 || viewsSummary?.entityViews
          ? Number(viewsSummary?.entityViews)
          : null;
      setTabViews(entityViews);
      return;
    }

    if (!contentType) {
      setTabViews(null);
      setTabCount(null);
      return;
    }

    const viewsKey = contentType;
    const viewsValue =
      viewsSummary?.[viewsKey] === 0 || viewsSummary?.[viewsKey]
        ? Number(viewsSummary?.[viewsKey])
        : null;
    setTabViews(viewsValue);

    dispatch(
      readEntityContentDetailsRequest(
        {
          contentType,
          typeofentity: "3",
          entityObjId: resolvedChurch._id,
          page: 1,
          limit: 20,
        },
        (res) => {
          const payload = res?.data || {};
          const rows = Array.isArray(payload)
            ? payload
            : Array.isArray(payload?.data)
            ? payload.data
            : [];
          const count = Number(rows?.[0]?.count || 0);
          setTabCount(count);
        }
      )
    );
  }, [activeTabs, resolvedChurch?._id, viewsSummary, dispatch]);

  useEffect(() => {
    if (activeTabs === "Image Gallery") {
      const count = Array.isArray(galleryList) ? galleryList.length : 0;
      setTabViews(null);
      setTabCount(count);
      return;
    }
  }, [activeTabs, galleryList]);
  const handleGallerySelect = (imageSet) => {
        // setGalleryId(imageSet?.target?.value?.id)
    setTumbNailUrlsInputs({
      webUploadUrl: imageSet?.target?.value?.web?.url || "",
      tabletUploadUrl: imageSet?.target?.value?.tablet?.url || "",
      mobileUploadUrl: imageSet?.target?.value?.mobile?.url || "",
    });
  };
    const { fetchAllChurches } =
    AllChurchHooks();
  return (
    <>
    <div className="flex flex-col md:flex-row h-full w-full min-w-0 flex-1 rounded-2xl overflow-hidden">
      <div className="flex h-full min-w-0 flex-1">
        <LanguageDrawer
          languageData={readLanguageData}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setActiveLanguageDetails={setActiveLanguageDetails}
          languagemeta={languagemeta}
          setIsLanguageSave={setIsLanguageSave}
        />
        <div className="flex h-full min-w-0 flex-1">
          <div className="flex flex-col h-full w-full min-w-0 bg-greyishV2 bg-opacity-50 md:border-l md:border-r border-greyish border-opacity-30 overflow-auto">
            {/* HEADER */}
            <div className={`pt-2 ${hideUI?'h-[124px]':'h-[55px]'} px-4 border-b border-[#28292a] w-full`}>
              <div className="flex gap-4 items-center justify-between">
              <p className="text-white font-semibold text-lg">
              {activeTab === "en"
  ? rowData?.churchName || 'Add Ministry'
  : rowData?.churchName
    ? `Translate Church to ${activeLanguageDetails?.language_name}`
    : 'Add Ministry'}

              </p>

              <div className="flex items-center gap-5">
                {activeTab !== "en" && data?._id && (
                  <p
                    className="flex items-center gap-1 text-greyish text-[11px] font-medium cursor-pointer whitespace-nowrap"
                    onClick={updateStateWithTranslation}
                  >
                    <img src={reload} alt="" /> Auto fill data with google
                    translation
                  </p>
                )}
                {data?._id && (
                  <button
                    className="text-yellowish bg-blackish font-medium text-[12px] whitespace-nowrap border border-yellowish rounded-xl py-2 px-6"
                    onClick={handleSendNotification}
                  >
                    Send Notification
                  </button>
                )}
                {activeTab === "en" ? (
                activeTabs==='Ministries' &&
                  <div className="w-full flex items-end justify-end gap-4">
                    {rowData?._id ? (
                      <button
                        className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                        onClick={async () => {
                          try {
                            await handleUpdateChurch(formValues); // ✅ wait for update
                            if (typeof onClose === "function") onClose(); // ✅ close modal only if success
                          } catch (err) {
                                                        // optionally keep modal open
                          }
                        }}
                      >
                        Update Ministry
                      </button>
                    ) : (
                      <button
                        className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                        onClick={async () => {
                          try {
                            await handleSave({
                              onSuccess: () => navigate("/ministry/all"),
                            }); // wait until API completes and toast appears
                            if (typeof onClose === "function") onClose(); // now close the modal
                          } catch (err) {
                                                        // optionally keep modal open or close anyway
                          }
                        }}
                      >
                        Save Ministry
                      </button>
                    )}
                  </div>
                ) : data?._id ? (
                  <div className="w-full flex items-end justify-end gap-4">
                    <button
                      className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                      onClick={handleSaveLanguage}
                    >
                      Save Language
                    </button>
                  </div>
                ) : null}
              </div>
              </div>
             {hideUI && <div className="relative">
  {/* <select
    name="church_id"
    className="focus:ring-0 focus:outline-none appearance-none bg-blackish p-2 w-1/2 text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10 pr-10"
    onChange={handleIdChange} // ✅ Pass event
  >
    <option value="">Select Church</option>
    {churches?.data && churches.data.length > 0 ? (
      churches.data.map((church) => (
        <option key={church._id} value={church._id}>
          {church.churchName}
        </option>
      ))
    ) : (
      <option disabled>No churches available</option>
    )}
  </select> */}

  {/* Custom arrow */}
  {/* <div className="pointer-events-none absolute inset-y-0 right-[52%] flex items-center text-white mt-2">
    <svg
      className="w-4 h-4"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M19 9l-7 7-7-7"
      />
    </svg>
  </div> */}
    <div className="flex items-center w-full min-w-0 rounded-lg mt-2">
      {/* Tabs Viewport */}
      <div ref={tabsViewportRef} className="overflow-hidden flex-1 min-w-0">
        {/* Slider track */}
        <div
          className="flex transition-transform duration-500 ease-in-out"
          style={{
            transform: `translateX(-${slideIndex * 100}%)`,
          }}
        >
          {/* Each slide group */}
          {Array.from({ length: totalSlides }).map((_, slideIdx) => {
            const start = slideIdx * max;
            const slideTabs = tabs.slice(start, start + max);
            return (
              <div
                key={slideIdx}
                className="flex w-full min-w-full flex-shrink-0 gap-3 overflow-hidden"
              >
                {slideTabs.map((tab, i) => (
                  <button
                    key={i}
                    onClick={() => setActiveTabs(tab)}
                    className={`min-w-0 flex-1 truncate px-3 py-2 rounded-lg font-semibold transition-colors whitespace-nowrap ${
                      activeTabs === tab
                        ? "bg-[#F8BA34] text-black"
                        : "text-gray-400 hover:text-black hover:bg-[#F8BA34]/70"
                    }`}
                  >
                    {tab}
                  </button>
                ))}
              </div>
            );
          })}
        </div>
      </div>

      {/* Arrows stacked vertically */}
      <div className="flex flex-col items-center ml-4 space-y-1">
        <button
          onClick={handleNext}
          disabled={slideIndex >= totalSlides - 1}
          className=" rounded-full transition-colors"
        >
          <FaArrowRight
            className={`text-ms ${
              slideIndex >= totalSlides - 1 ? "text-gray-500" : "text-[#F8BA34]"
            }`}
          />
        </button>

        <button
          onClick={handlePrev}
          disabled={slideIndex === 0}
          className=" rounded-full transition-colors"
        >
          <FaArrowLeft
            className={`text-md ${
              slideIndex === 0 ? "text-gray-500" : "text-[#F8BA34]"
            }`}
          />
        </button>
      </div>
    </div>
</div>
}
            </div>

            {/* TAB CONTENT */}
            <div className="mt-4">
        {activeTabs === "Ministries" ? (
          activeTab !== "en" && !data?._id ? (
            <div className="flex items-center justify-center text-white gap-1 py-28">
              Ministry translation in{" "}
              <span className="italic">
                {activeLanguageDetails?.language_name}
              </span>{" "}
              is available for saved Ministry
            </div>
          ) : (
            <div className="px-4 my-4 h-full">
              <div className="overflow-y-auto overflow-x-hidden">
                <div className="grid md:grid-cols-2 grid-cols-1 grid-rows-1 gap-x-4 gap-y-4 mx-1 w-full">
                  {/* FORM FIELDS */}
                  {/* Church Title */}
                  <div className="md:col-span-2 col-span-1 max-w-[99%]">
                    <label className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2">
                      Ministry Title *
                      <FaInfoCircle
                        data-tooltip-id="add_church"
                        data-tooltip-content="Enter the Ministry Title"
                      />
                    </label>
                    <input
                      name="church_title"
                      placeholder="Enter Ministry Title"
                      type="text"
                      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
                      value={formValues.churchName}
                      onChange={handleLocalChange}
                    />
                    {videoErrors?.church_title && (
                      <p className="text-red-500 text-[10px] left-2">
                        Ministry Title is a required field
                      </p>
                    )}
                  </div>

                  {/* Church Tagline */}
                  <div className="md:col-span-2 col-span-1 max-w-[99%]">
                    <label className="text-[12px] text-greyish font-medium leading-4">
                      Ministry Tagline
                    </label>
                    <input
                      name="church_tagline"
                      placeholder="Enter Ministry Tagline"
                      type="text"
                      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
                      value={formValues.tagline}
                      onChange={handleLocalChange}
                    />
                  </div>

                  {/* Church Description */}
                  <div className="md:col-span-2 col-span-1 max-w-[98%]">
  <label className="text-[12px] text-greyish font-medium leading-4">
    Ministry Description *
  </label>

  <div className="mt-2 bg-blackish rounded-md overflow-hidden">
  <ReactQuill
  theme="snow"
  value={formValues.description}
  onChange={(value) => {
    // 🔥 remove background-color styles
    const cleanValue = sanitizeQuill(value);


    setFormValues((prev) => ({
      ...prev,
      description: cleanValue,
    }));

    handleChange({
      target: {
        name: "church_description",
        value: cleanValue,
      },
    });
  }}
  placeholder="Enter Ministry Description"
/>

  </div>

  {videoErrors?.church_description && (
    <p className="text-red-500 text-[10px] mt-1">
      Ministry Description is required
    </p>
  )}
</div>



                  {/* Google Map Input */}
                  <div className="md:col-span-2 col-span-1 max-w-[99%]">
                  <GoogleMapInput
  defaultLocation={{
    lat: formValues.latitude || 40.7128,
    lng: formValues.longitude || -74.0060,
  }}
  onLocationChange={({ lat, lng, address }) => {
    setSelectedLocation({ lat, lng, address });

    // ✅ Update formValues directly
    setFormValues(prev => ({
      ...prev,
      address: address,
      latitude: lat,
      longitude: lng
    }));

    // Also call handleChange for your hook if needed
    handleChange({
      target: { name: "church_address", value: address },
    });
    handleChange({
      target: { name: "church_latitude", value: lat },
    });
    handleChange({
      target: { name: "church_longitude", value: lng },
    });
  }}
/>
                  </div>

                  {/* Church Address */}
                  <div className="md:col-span-2 col-span-1 max-w-[99%]">
                    <label className="text-[12px] text-greyish font-medium leading-4">
                      Ministry Address *
                    </label>
                    <input
                      name="church_address"
                      placeholder="Enter Ministry Address"
                      type="text"
                      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
                      value={selectedLocation?.address || formValues.address}
                      onChange={handleLocalChange}
                    />
                    {videoErrors?.church_address && (
                      <p className="text-red-500 text-[10px] left-2">
                        Ministry Address is a required field
                      </p>
                    )}
                  </div>

                  {/* Latitude & Longitude (hidden) */}
                  <div className="md:col-span-1 col-span-1 hidden">
                    <label className="text-[12px] text-greyish font-medium leading-4">
                      Latitude *
                    </label>
                    <input
                      type="text"
                      name="church_latitude"
                      placeholder="Enter Latitude"
                      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
                      value={selectedLocation?.lat || formValues.latitude}
                      onChange={handleLocalChange}
                    />
                  </div>
                  <div className="md:col-span-1 col-span-1 hidden">
                    <label className="text-[12px] text-greyish font-medium leading-4">
                      Longitude *
                    </label>
                    <input
                      type="text"
                      name="church_longitude"
                      placeholder="Enter Longitude"
                      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
                      value={selectedLocation?.lng || formValues.longitude}
                      onChange={handleLocalChange}
                    />
                  </div>

                  {/* Contact Email */}
                  <div className="md:col-span-1 col-span-1 ">
                    <label className="text-[12px] text-greyish font-medium leading-4">
                      Contact Email *
                    </label>
                    <input
                      name="church_email"
                      placeholder="Enter Ministry Email"
                      type="email"
                      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
                      value={formValues.contactemail}
                      onChange={handleLocalChange}
                    />
                    {videoErrors?.church_email && (
                      <p className="text-red-500 text-[10px] left-2">
                        Contact Email is required
                      </p>
                    )}
                  </div>

                  {/* Contact Phone */}
                  <div className="md:col-span-1 col-span-1 max-w-[98%]">
                    <label className="text-[12px] text-greyish font-medium leading-4">
                      Contact Phone *
                    </label>
                    <input
                      name="church_phone"
                      placeholder="Enter Contact Phone"
                      type="tel"
                      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
                      value={formValues.contactphone}
                      onChange={handleLocalChange}
                    />
                    {videoErrors?.church_phone && (
                      <p className="text-red-500 text-[10px] left-2">
                        Contact Phone is required
                      </p>
                    )}
                  </div>

                  {/* Website */}
                  <div className="md:col-span-2 col-span-1 flex gap-4 max-w-[99%]">
  {/* Contact Website */}
  <div className="flex-1">
    <label className="text-[12px] text-greyish font-medium leading-4">
      Contact Website
    </label>
    <input
      name="church_website"
      placeholder="https://example.com"
      type="url"
      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
      value={formValues.website}
      onChange={handleLocalChange}
    />
  </div>

  {/* Give URL */}
  <div className="flex-1 ">
    <label className="text-[12px] text-greyish font-medium leading-4">
      Give URL
    </label>
    <input
      name="church_give_url"
      placeholder="https://donate.example.com"
      type="url"
      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
      value={formValues.giveUrl}
      onChange={handleLocalChange}
    />
  </div>
</div>


                  {/* Logo Upload */}
                  <UploadControlsV2
                    tooltipTitle="Upload Ministry Logo"
                    className="my-2 col-span-2 mr-1"
                    title="Ministry Logo *"
                    subtitle="Upload Image"
                    showPreview={true}

                    handleChangeUrl={(event) =>
                      handleInputChange(event, setTumbNailUrlsInputs)
                    }
                    webUploadProgressId="logoUrlAddChurchLogo"
                    handleWebFileUpload={(e) =>
                      handleFileInputChange(
                        setTumbNailUrlsInputs,
                        "logoUrl",
                        e.target.files[0],
                        null,
                        "logoUrlAddChurchLogo",
                        false,
                        "church_logo_urls"
                      )
                    }
                    webUploadName="logoUrl"
                    webUploadUrl={tumbNailUrlsInputs?.logoUrl ?? formValues?.logourl}
                    handleWebPreview={() => {
                      setIsImage(true);
                      setShowModal(true);
                      setCurrentUrl(tumbNailUrlsInputs?.logoUrl ?? formValues?.logourl);
                    }}
                    isFieldRequired={videoErrors?.church_logo_urls}
                    requiredMessage="Ministry Logo is required"
                    showMobileUpload={false}
                    showTabletUpload={false}
                    showWebUpload={true}
                  />

                </div>
                {/* <GalleryPickerField
  label=" Cover Image"
  name="galleryImage"
  church={church}
  value={{
    web: { url: tumbNailUrlsInputs?.webUploadUrl },
    tablet: { url: tumbNailUrlsInputs?.tabletUploadUrl },
    mobile: { url: tumbNailUrlsInputs?.mobileUploadUrl },
  }}
  handleChange={handleGallerySelect}
/> */}
              </div>
            </div>
          )
        ) : ActiveComponent ? (
          <ActiveComponent church={resolvedChurch} typeofentity={3} />
        ) : (
          <div>Coming soon...</div>
        )}
      </div>

            <Tooltip
              id="add_church"
              className="border border-greyish border-opacity-20"
            />
          </div>
        </div>
      </div>

      {/* SIDE PANEL */}
      <CollapsibleRightPanel title="Stats">
        <CustomTabsV2
          tabHeight="h-[64px]"
          tabsTitleArray={["Stats"]}
          tabsContentObject={{
            Stats: (
              <div className="mt-8 flex items-center justify-center w-full text-white">
                {resolvedChurch?._id ? (
                  <div className="w-full px-8">
                    {tabViews !== null && (
                      <p>
                        Views : <strong>{tabViews}</strong>
                      </p>
                    )}
                    <p className="mt-2">
                      Count : <strong>{tabCount ?? 0}</strong>
                    </p>
                  </div>
                ) : (
                  <>No stats available</>
                )}
              </div>
            ),
          }}
        />
        {activeTabs !== "Ministries" && SideActiveComponent ? (
          <SideActiveComponent />
        ) : null}
      </CollapsibleRightPanel>
    </div>
    <ReactModal isOpen={showModal} onRequestClose={() => setShowModal(false)}>
            <div className="flex justify-center h-full w-full relative">
              <div
                className="absolute top-0 right-0 cursor-pointer"
                onClick={() => setShowModal(false)}
              >
                <ImCross />
              </div>
              {isImage ? (
                <img className="h-full" src={currentUrl} />
              ) : (
                <video className="h-full" controls autoPlay>
                  <source src={currentUrl} />
                </video>
              )}
            </div>
          </ReactModal>
    </>
  );
};

export default AddVideosFields;
